<template>
  <div v-if="load && showContent">
    <v-skeleton-loader type="article"></v-skeleton-loader>
  </div>
  <div v-else>
    <div v-if="showContent">
      <v-row v-if="Object.keys(courses).length != 0" class="mx-0">
        <v-col v-for="(course, year) in courses" :key="year" class="py-6 px-0 d-flex">
          <!-- width=300 -->
          <v-card :title="year + ' курс'" :class="$model.isTeacher ? 'ml-4' : ''">
            <v-card-text>
              <v-row v-for="(groups, disc, i) in course" :key="i">
                <v-col cols="12" class="pa-0">
                  <a :href="$model.wwwroot +
                    '/course/view.php?id=' +
                    groups[0].courseId
                    " target="_blank">{{ disc }}</a>
                  &nbsp;
                  <span style="float: right;">
                    <span v-for="(group, i) in groups" :key="group.grName">
                      {{ group.grName }}
                      <br v-if="groups.length - 1 == i" />
                    </span>
                  </span>
                  <div style="clear: both;"></div>
                </v-col>
                <v-divider class="my-2 border-opacity-100"></v-divider>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <div v-else>Нет данных для отображения</div>
    </div>
    <div v-else class="cursor-pointer">
      <v-col class="d-flex flex-column align-center">
        <v-icon color="info" icon="mdi-book-education-outline"></v-icon>
      </v-col>

      <v-col style="word-break: break-word" class="d-flex flex-column align-center">
        <span>Курсы этого семестра</span>
      </v-col>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //поле data из psm_desktop_widgets
    data: {
      required: true,
    },
    showContent: {
      default: false,
      type: Boolean
    }
  },
  name: "myCoursesWidget",
  data() {
    return {
      courses: {},
      load: false
    };
  },
  watch: {
    showContent: function (newVal) {
      if (newVal && Object.keys(this.courses).length == 0) {
        this.loadData();
      }
    }
  },
  created() {
    if (!this.showContent) {
      return
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.load = true;
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/widgets/myCourses/get"
        )
        .then((response) => {
          this.courses = response.data;
          this.load = false;
        })
        .catch((error) => {
          this.load = false
          console.log(error);
        });
    }
  },
};
</script>
<style lang="scss">
#procollege_desktop2 {
  p.courses {
    padding: 0;
    margin: 0;
  }
}
</style>
